module.exports = __webpack_public_path__ + "static/media/main-qrcode.d5f5de08.svg";